// services/carWashApi.ts
import { getCategory, getShoppingCart, patchCustomer, postOrder } from "src/shared/services/servicesv2";
import { Order, CarDetailState } from "../../types";

// ✅ Fetch customer order by ID
export const fetchOrderData = async (id: string): Promise<Order> => {
  const response = await getShoppingCart(id);
  if (!response.data?.result) {
    throw new Error("Unexpected response structure.");
  }
  return response.data.result[0];
};

// ✅ Fetch all active categories
export const fetchCategories = async (): Promise<CarDetailState[]> => {
  const response = await getCategory();
  return response.data.categoryDetails || [];
};

// ✅ Confirm order
export const confirmOrder = async (orderData: any) => {
  const response = await postOrder(orderData);
  return response.data;
};

// ✅ Update customer by ID
export const updateCustomer = async (id: string, customerData: any) => {
  await patchCustomer(id, customerData);
};
